
import { observable, action, runInAction } from 'mobx';
import { message } from 'antd';
import moment from 'moment';

class store {
    @observable data = [];

    getData = (date) => {
        return new Promise((res, rej) => {
            fetch(`/_5_1_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
                runInAction(() => {
                    this.data = x.data || []
                })
                res(x);
            }).catch(err => {
                rej(err);
            })
        })
    }
}

const revenue = new store();

export default revenue;


// WEBPACK FOOTER //
// ./src/store/5/revenue.js